<div class="filters-mobile">
    <div class="filters-mobile__header">
        <h2 class="filters-mobile__header--title">Filters</h2>
        <button mat-button class="filters-mobile__header--reset" (click)="clearFilters()">Clear</button>
    </div>
    <div class="filters-mobile__content">
        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Arriving on</label>
            <div class="filters-mobile__content--form">
                <div class="material-datepicker">
                    <mat-form-field appearance="fill">
                        <input type="text" [matDatepicker]="arrivingOn"
                               [(ngModel)]="selectedFilters.from" matInput
                               (focus)="arrivingOn.open()">
                        <mat-datepicker-toggle matIconSuffix [for]="arrivingOn"></mat-datepicker-toggle>
                        <mat-datepicker #arrivingOn></mat-datepicker>
                    </mat-form-field>
                </div>
                <button class="field-box__password-btn">
                </button>
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Leaving on</label>
            <div class="filters-mobile__content--form">
                <div class="material-datepicker">
                    <mat-form-field appearance="fill">
                        <input type="text" [matDatepicker]="leavingOn"
                               [(ngModel)]="selectedFilters.to" matInput
                               (focus)="leavingOn.open()">
                        <mat-datepicker-toggle matIconSuffix [for]="leavingOn"></mat-datepicker-toggle>
                        <mat-datepicker #leavingOn></mat-datepicker>
                    </mat-form-field>
                </div>
                <button class="field-box__password-btn">
                </button>
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Scores</label>
            <div class="filters-mobile__content--form">
                <mat-radio-group [(ngModel)]="selectedFilters.score">
                    @for (score of scoresOptions; track $index) {
                        <mat-radio-button [value]="score.value">
                            {{ score.label }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
        </div>
    </div>
    <div class="filters-mobile__footer">
        <button class="btn-default btn-blue filters-mobile__footer--apply" (click)="applyFilters()">Apply</button>
    </div>
</div>
